import React from 'react';
import * as S from './InvoicesSection.styles';
import { BusinessTabs } from '@/features/Profile/core';
import { useResponsive } from '@/hooks/useResponsive';
import { BusinessTabName } from '@/features/Profile/core/BusinessTabs/BusinessTabs.types';

export function InvoicesSection() {
  const { isDesktop } = useResponsive();

  return (
    <S.Box>
      {!isDesktop && <BusinessTabs activeTab={BusinessTabName.Invoices} />}
      <div />
    </S.Box>
  );
}
